import { checkPermission } from "@utils/user-permissions";
import {
  DRY_BULK_VESSEL_NOMINATION_ACCESS_PERMISSION,
  FOTT_VESSEL_NOMINATION_ACCESS_PERMISSION,
} from "../constants";

export const NOMINATION_TYPE = {
  LIQUID_BULK: "LIQUID_BULK",
  DRY_BULK: "DRY_BULK",
} as const;

export interface NominationTypeOption {
  label: string;
  value: string;
}

const canRequestFottVesselNomination = (userActionPermissions: string[]) =>
  checkPermission(userActionPermissions, "canRequestFottVesselNomination");

const canRequestDryBulkVesselNomination = (userActionPermissions: string[]) =>
  checkPermission(userActionPermissions, "canRequestDryBulkVesselNomination");

export const canRequestVesselNomination = (userActionPermissions: string[]) =>
  canRequestFottVesselNomination(userActionPermissions) ||
  canRequestDryBulkVesselNomination(userActionPermissions);

export const getNominationTypeOptions = (
  userActionPermissions: string[],
  t: (key: string) => string,
): NominationTypeOption[] => [
  ...(canRequestFottVesselNomination(userActionPermissions)
    ? [
        {
          label: t("vessel-nomination.vessel-scan.types.liquid-bulk"),
          value: NOMINATION_TYPE.LIQUID_BULK,
        },
      ]
    : []),
  ...(canRequestDryBulkVesselNomination(userActionPermissions)
    ? [
        {
          label: t("vessel-nomination.vessel-scan.types.dry-bulk"),
          value: NOMINATION_TYPE.DRY_BULK,
        },
      ]
    : []),
];

/** Nomination types the user may read (route/menu access permissions from /me). */
export const getReadableNominationTypes = (userAccessPermissions: string[]): string[] => [
  ...(checkPermission(userAccessPermissions, FOTT_VESSEL_NOMINATION_ACCESS_PERMISSION)
    ? [NOMINATION_TYPE.LIQUID_BULK]
    : []),
  ...(checkPermission(userAccessPermissions, DRY_BULK_VESSEL_NOMINATION_ACCESS_PERMISSION)
    ? [NOMINATION_TYPE.DRY_BULK]
    : []),
];
